"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    module.factory('prFeatureFlipper', [
        'pr.httpPostCache',
        'pr.API_ROUTES',
        function (httpPostCache, API_ROUTES) {
            return {
                isFeatureFlipperEnabled: isFeatureFlipperEnabled,
                areFeatureFlippersEnabled: areFeatureFlippersEnabled
            };
            function isFeatureFlipperEnabled(featureFlipperId) {
                if (!featureFlipperId) {
                    throw Error('No feature flipper id was provided.');
                }
                return areFeatureFlippersEnabled([featureFlipperId]).then(function (ret) {
                    return ret[featureFlipperId];
                });
            }
            function areFeatureFlippersEnabled(featureFlipperIds) {
                if (!featureFlipperIds || !lodash_1.default.isArray(featureFlipperIds)) {
                    throw Error('No valid feature flipper ids were provided.');
                }
                return httpPostCache.post(API_ROUTES.FEATURE_FLIPPER, featureFlipperIds, { cache: true })
                    .then(function (response) {
                    return response.data;
                }).catch(function (err) {
                    console.error('Could not determine if ' + featureFlipperIds + ' are enabled.', err);
                    // Log an error but return false for each feature flipper id
                    // to not prevent the service user from crashing.
                    var ret = {};
                    lodash_1.default.forEach(featureFlipperIds, function (id) {
                        ret[id] = false;
                    });
                    return ret;
                });
            }
        }
    ]);
})(angular_1.module('qualtrics.pr'));
